import React from 'react';
import Navbar from './home/Navbar';
import Footer from './Footer';
import ZendeskOcr from './ZendeskOcr';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';

function ZendeskOcrPage() {
  const { events } = useGoogleAnalytics();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    events.pageView('Zendesk OCR');
  }, [events]);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      <div className="flex-grow pt-16">
        <ZendeskOcr />
      </div>
      <Footer />
    </div>
  );
}

export default ZendeskOcrPage;
